import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import "react-quill/dist/quill.core.css";
import { Container } from "reactstrap";
import { NavbarAdmin } from "../../../shared/admin/NavbarAdmin";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { readingTime } from 'reading-time-estimator';
import Unauthorized from "../../../shared/Unauthorized";

function Editor(props) {
  const [theme, setTheme] = useState("snow");
  const { id, inputRef, placeholder } = props;
  const params = useParams();
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const accessToken = useSelector((state) => state.form.accessToken);
  const navigate = useNavigate();
  const [date, setDate] = useState();

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/blog/description/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .then((response) => {
        setText(response.data.text);
        setTitle(response.data.title);
        setCategory(response.data.category);
        setDate(response.data.dateWritten);
      });
  }, [accessToken, params.id]);

  const saveText = () => {
    var time = readingTime(text, 200);

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/blog/update/${params.id}`,
        {
          text: text,
          title: title,
          category: category,
          LengthRead: time.minutes,
          DateWritten: date,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .then((response) => {
        navigate("/admin/list/blog/");
      });
  };

  if (!accessToken) {
    <Unauthorized />;
  } else if (accessToken) {
  return (
    <>
      <NavbarAdmin />
      <Container className="animate-in">
        <div className="spacer mobile main"></div>
        <div className="d-flex justify-content-evenly align-center">
          <Link className="editor-button left" to="/admin/list/blog">
            <button className="send-button editor">ZPĚT</button>
          </Link>
          <Link
            className="editor-button right"
            to={`/admin/add/blog/images/list/${params.id}`}
          >
            <button className="send-button editor">OBRÁZKY</button>
          </Link>
        </div>
        <div className="login-form">
          <input
            name="title"
            type="text"
            placeholder="Název"
            className="control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            name="category"
            type="text"
            placeholder="Cena"
            className="control mb-3"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </div>
        <ReactQuill
          id={id}
          ref={inputRef}
          theme={theme}
          onChange={(value) => setText(value)}
          value={text}
          modules={{
            toolbar: {
              ...Editor.modules.toolbar,
              handlers: {},
            },
            ...Editor.modules,
          }}
          formats={Editor.formats}
          bounds={".app"}
          placeholder={placeholder ?? ""}
        />
        <button
          className="send-button save mb-3"
          type="submit"
          onClick={() => saveText()}
        >
          ULOŽIT
        </button>
      </Container>
    </>
  );}
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
  toolbar: [
    // [{ header: '1' }, { header: '2' }, { font: [] }],
    // [{ size: [] }],
    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
    [{ align: [] }],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export default Editor;
